import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "onClick", "loadingText"];
import { useState } from 'react';
import styled from 'foundations-theming/utils';
import { BREAKPOINTS } from 'unsubscribe-ui/constants';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LoadingSpinner = styled.div.withConfig({
  displayName: "BaseButton__LoadingSpinner"
})(({
  theme
}) => ({
  width: '0.75rem',
  height: '0.75rem',
  borderWidth: theme.borderWidth[100],
  borderStyle: 'solid',
  borderColor: 'transparent',
  borderTop: theme.borderWidth[100],
  borderTopStyle: 'solid',
  borderRadius: theme.borderRadius[400],
  animation: 'spin 1s linear infinite',
  '@keyframes spin': {
    '0%': {
      transform: 'rotate(0deg)'
    },
    '100%': {
      transform: 'rotate(360deg)'
    }
  }
}));
const ButtonContent = styled.div.withConfig({
  displayName: "BaseButton__ButtonContent"
})(({
  $isLoading
}) => ({
  visibility: $isLoading ? 'hidden' : 'visible',
  minWidth: '8rem'
}));
const SpinnerWrapper = styled.div.withConfig({
  displayName: "BaseButton__SpinnerWrapper"
})({
  lineHeight: '1rem',
  minWidth: '8rem',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
});
const DefaultBaseButton = styled.button.attrs(props => ({
  'aria-disabled': props['aria-disabled'] || false
}))(({
  block,
  theme
}) => ({
  MozOsxFontSmoothing: 'auto',
  WebkitFontSmoothing: 'auto',
  borderRadius: theme.borderRadius[200],
  borderStyle: 'solid',
  borderWidth: theme.borderWidth[100],
  cursor: 'pointer',
  fontFamily: theme.typography['body-125'].fontFamily,
  fontDisplay: 'swap',
  fontSize: theme.typography['body-125'].fontSize,
  fontWeight: theme.typography['body-125'].fontWeight,
  lineHeight: '1rem',
  maxWidth: '100%',
  overflow: 'hidden',
  padding: `${theme.space[300]} ${theme.space[500]}`,
  textAlign: 'center',
  textOverflow: 'ellipsis',
  textTransform: 'none',
  transition: 'all 150ms ease-out',
  userSelect: 'none',
  verticalAlign: 'middle',
  whiteSpace: 'nowrap',
  width: block ? '100%' : 'initial',
  ':hover': {
    textDecoration: 'none'
  },
  ':disabled': {
    cursor: 'not-allowed',
    opacity: 0.5
  },
  [`@media (max-width: ${BREAKPOINTS.tablet})`]: {
    width: '100%'
  }
}));
const LoadingText = styled.span.withConfig({
  displayName: "BaseButton__LoadingText"
})(({
  theme
}) => ({
  paddingLeft: theme.space[100]
}));
const BaseButton = _ref => {
  let {
      children,
      onClick,
      loadingText
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const [isLoading, setIsLoading] = useState(false);
  const handleClick = async () => {
    if (!onClick || isLoading) {
      return;
    }
    setIsLoading(true);
    try {
      await onClick();
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };
  return /*#__PURE__*/_jsx(DefaultBaseButton, Object.assign({
    disabled: isLoading,
    onClick: () => void handleClick()
  }, rest, {
    children: isLoading ? /*#__PURE__*/_jsx(SpinnerWrapper, {
      children: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(LoadingSpinner, {}), loadingText && /*#__PURE__*/_jsx(LoadingText, {
          children: loadingText
        })]
      })
    }) : /*#__PURE__*/_jsx(ButtonContent, {
      $isLoading: isLoading,
      children: children
    })
  }));
};
export default BaseButton;